
























































import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import DateFormatter from "../../shared/DateFormatter";
import Loading from "../general/Loading.vue";
import GroupsBookingDetails from "./GroupsBookingDetails.vue";

import UserJson from "../../shared/UserJson";
import GroupBookingJson from "../../shared/GroupBookingJson";
import CustomerJson from "../../shared/CustomerJson";

import { GroupBookingStatus } from "../../shared/GroupBookingStatus";
import { Gender } from "../../shared/Gender";
import { UserPermissionRank } from "../../shared/UserPermissionRank";
import TableView, { TableViewColumnDefinitions } from "../controls/TableView.vue";

export default Vue.extend({
  name: "GroupsOverview",
  components: {
    Loading,
    TableView,
    GroupsBookingDetails,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    appFrameClickedButton: Object,
    GroupsBookingStatusNames: Object,
  },
  data() {
    return {
      DateFormatter: DateFormatter,
      GroupBookingStatus: GroupBookingStatus,
      showDetails: false,
      UserPermissionRank: UserPermissionRank,
      attentionalGroupBookings: null as GroupBookingJson[] | null,
      attentionalGroupBookingsMoreAvailable: null as boolean | null,
      selectedGroupBookingId: null as number | null,
      selectedGroupBooking: null as GroupBookingJson | null,
      detailsMode: "read",
    };
  },
  created() {
    this.$emit("showAppFrameButtons", { reload: true });
    this.loadData();
  },
  mounted() {},
  methods: {
    toggleDetails: function () {
      this.showDetails = !this.showDetails;
      if (this.showDetails == false) {
        this.loadData();
      }
    },

    loadData() {
      this.loadAttentionalGroupBookings();
    },

    async reloadSelectedGroupBooking() {
      this.selectedGroupBooking = null;
      this.toggleDetails();
      if (this.selectedGroupBookingId != null) {
        try {
          this.selectedGroupBooking = await this.restClient.getGroupBooking(this.selectedGroupBookingId);
          this.openDetails(this.selectedGroupBooking, "read");
        } catch (e) {
          alert(e.message);
        }
      }
    },

    async loadAttentionalGroupBookings(loadMore: null = null) {
      var states: GroupBookingStatus[] = [
        GroupBookingStatus.requested,
        GroupBookingStatus.offerAccepted,
        GroupBookingStatus.cancellationPending,
      ];

      var afterDateTime = null;
      var beforeDateTime = null;
      var skipAmount = null as number | null;

      //load more
      if (loadMore && this.attentionalGroupBookings != null) {
        this.attentionalGroupBookingsMoreAvailable = null;

        skipAmount = this.attentionalGroupBookings.length;
      } else {
        this.attentionalGroupBookings = null;
      }

      //final load
      if (this.restClient != null) {
        try {
          let bookings = await this.restClient.getGroupBookings(
            states,
            null,
            afterDateTime,
            beforeDateTime,
            null,
            null,
            skipAmount
          );

          if (loadMore && this.attentionalGroupBookings != null) {
            this.attentionalGroupBookings = this.attentionalGroupBookings.concat(bookings.groupBookings);
          } else {
            this.attentionalGroupBookings = bookings.groupBookings;
          }

          this.attentionalGroupBookingsMoreAvailable = bookings.moreAvailable;
        } catch (e) {
          alert(e.message);
        }
      }
    },

    openDetails(item: GroupBookingJson | null, mode: string) {
      if (item != null) {
        //this.selectedBirthday = JSON.parse(JSON.stringify(item))
        this.selectedGroupBookingId = item.ID;
      } else {
        this.selectedGroupBookingId = null;
      }

      this.detailsMode = mode;
      this.toggleDetails();
    },

    //tableView
    tableViewButtonClicked(button: string, item: any) {
      if (button == "openDetailsEdit") {
        this.openDetails(item, "edit");
      }
    },

    tableViewItemClicked(item: any) {
      this.openDetails(item, "read");
    },
  },
  watch: {
    appFrameClickedButton: function () {
      if (this.appFrameClickedButton.reload) {
        this.loadData();
      }
    },
  },
  computed: {
    groupColumns: function (): TableViewColumnDefinitions<GroupBookingJson>[] {
      let vue = this;

      return [
        {
          th: "Name",
          td: (i) =>
            i.customer.guardianLastName != ""
              ? i.customer.guardianLastName + ", " + i.customer.guardianFirstName
              : "--",
        },
        {
          th: "Gruppe",
          td: (i) => (i.customer.guardianOrganisation != "" ? i.customer.guardianOrganisation : "--"),
        },
        {
          th: "Datum",
          td: (i) => DateFormatter.formatDateWeekday(new Date(i.beginDateTime)),
          sortBy: (i) => i.beginDateTime,
        },
        {
          th: "Uhrzeit",
          td: (i) =>
            DateFormatter.formatTime(new Date(i.beginDateTime)) +
            " – " +
            DateFormatter.formatTime(new Date(i.endDateTime)),
        },
        {
          th: "Status",
          td: (i) => vue.GroupsBookingStatusNames[i.state],
        },
        {
          th: "",
          td: (i) => "Daten bearbeiten",
          style: (i) => "text-align:right",
          button: "openDetailsEdit",
        },
      ] as TableViewColumnDefinitions<GroupBookingJson>[];
    },
  },
});
